// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.z-10 {
  z-index: 10;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-full {
  height: 100%;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.columns-3 {
  columns: 3;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.appointment-popup {
  padding: 3px 0px 10px 15px;
}

@media screen and (max-width: 768px) {
  .appointment-popup {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    top: 0;
    border-radius: 0;
    overflow: auto;
    height: calc(100% - 6.4rem);
    min-height: auto;
    max-height: 100%;
  }
}
.appointment-popup .appointment-user-wrapper {
  background: #2c3153;
  flex: 0 0 25rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper {
    flex-wrap: wrap;
    display: flex;
    width: 100%;
  }
}
.appointment-popup .appointment-user-wrapper .user-avatar {
  position: relative;
  padding-bottom: 100%;
  width: 100%;
  overflow: hidden;
}

.appointment-popup .appointment-user-wrapper .user-avatar img {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .user-avatar {
    flex: 0 0 35%;
    padding-bottom: 35%;
  }
}
.appointment-popup .appointment-user-wrapper .appointment-user {
  padding: 2rem 2rem 0 2rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .appointment-user {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 2rem;
    flex-direction: column;
  }
}
.appointment-popup .appointment-user-wrapper .appointment-user .username {
  color: white;
  font-size: 1.8rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .specialization {
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.3rem;
  display: block;
  margin-top: 0.5rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation {
  display: flex;
  margin-top: 0.5rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation span {
  padding: 0.25rem !important;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation span:before {
  content: "\\f005";
  font-family: "Font Awesome 5 Pro";
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
  display: block;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation.five span:nth-child(-n+5):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.four span:nth-child(-n+4):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.three span:nth-child(-n+3):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.two span:nth-child(-n+2):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.one span:nth-child(-n+1):before {
  color: #ee5181;
}

.appointment-popup .appointment-user-wrapper .appointment-location {
  padding: 2rem 0;
  margin: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}

.appointment-popup .appointment-user-wrapper .appointment-location p {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 0;
  margin-bottom: 0.5rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .appointment-location {
    width: 100%;
    margin: 0;
  }
}
.appointment-popup .appointment-calendar {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  /* padding: 10px 8px; */
  /* left: 50%; */
  /* max-width: 90%; */
  background: white;
  border-radius: 8px;
  z-index: 1;
  /* transform: translateX(-50%);*/
}

.appointment-popup .appointment-calendar .calendar-nav {
  right: 0;
  position: absolute;
  margin-top: 0;
}

.current-week {
  /*mat-icon {
      font-size: 20px;
  }*/
  /*.calendar-nav {
      mat-icon {
          font-size: 18px;
      }
  }*/
}

.appointment-popup .appointment-calendar .current-week {
  display: flex;
  /*justify-content: space-between;*/
  padding: 8px 0;
  border-bottom: 1px solid #f3f3f3;
  align-items: center;
  width: auto;
  justify-content: space-between;
}

.appointment-popup .appointment-calendar .current-week > span {
  font-size: 16px;
  color: #5a5a5a;
  padding-left: 25px;
  line-height: 40px;
  clear: both;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.appointment-popup .appointment-calendar .current-week > span i {
  color: #333333;
  margin-right: 0.5rem;
  opacity: 0.7;
  width: 20px;
  text-align: center;
}

.appointment-popup .appointment-calendar .current-week .calendar-nav button {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 0;
  cursor: pointer;
  outline: none;
  color: #515151;
  width: 50px;
}

.appointment-popup .appointment-calendar .current-week .calendar-nav button:before {
  font-family: "Font Awesome 5 Pro";
  font-size: 2rem;
  padding: 0 1.5rem;
  display: block;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-calendar .current-week .calendar-nav {
    flex-wrap: wrap;
  }
  .appointment-popup .appointment-calendar .current-week .calendar-nav .calendar-nav button:before {
    padding: 0 1rem;
    font-size: 1.2rem;
  }
  .appointment-popup .appointment-calendar .current-week .calendar-nav > span {
    font-size: 1.5rem;
  }
}
.appointment-popup .appointment-calendar .calendar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week {
  border-bottom: 2px solid #158ec6;
  background-color: #353a48;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul {
  padding: 0;
  list-style: none;
  display: flex;
  width: 100%;
  margin: 0;
  height: 55px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul li {
  width: 100%;
  font-weight: 600;
  padding: 0.25rem 0;
  text-align: center;
  color: #d6d6d6;
  background-size: 100% 100%;
  background: rgb(84, 84, 84);
  background: linear-gradient(3deg, rgb(84, 84, 84) 0%, rgb(68, 68, 68) 100%);
  border-color: #333333;
  box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours {
  overflow: auto;
  height: 290px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours ul {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 5px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li {
  width: 100%;
  text-align: center;
  padding-top: 8px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  /* min-height: 0.7rem; */
  cursor: pointer;
  background: #11b3a4;
  border-radius: 3px;
  color: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  margin-bottom: 6px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty {
  background: none;
  box-shadow: none;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty:hover {
  background: none;
  box-shadow: none;
}

.calendar-hours::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.calendar-hours::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

.calendar-hours::-webkit-scrollbar-thumb {
  background: #158ec6;
  border: 0px none #ffffff;
  border-radius: 12px;
}
.calendar-hours::-webkit-scrollbar-thumb:hover {
  background: #919191;
}
.calendar-hours::-webkit-scrollbar-thumb:active {
  background: #158ec6;
}

.calendar-hours::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-bottom-right-radius: 6px;
}
.calendar-hours::-webkit-scrollbar-track:hover {
  background: #666666;
}
.calendar-hours::-webkit-scrollbar-track:active {
  background: #888888;
}

.calendar-hours::-webkit-scrollbar-corner {
  background: transparent;
}

.message-not-available-planning {
  height: 100px;
}

.btn-select-type {
  background: transparent !important;
}

.selected-type {
  background: #11b3a4 !important;
  color: white !important;
}

.select-lieux-consultation {
  background: #11b3a4;
}

.select-motif {
  background: #11b3a4;
}

.li-slot:not(:last-child):not(:first-child) {
  border-left: 0.5px solid #eaeaec;
  border-right: 0.5px solid #eaeaec;
}

.li-slot:first-child {
  border-right: 0.5px solid #eaeaec;
}

.li-slot:last-child {
  border-left: 0.5px solid #eaeaec;
}

.top-header-planning {
  border-bottom: 2px solid #158ec6;
  background-color: #353a48;
}

.calendar-wrapper-header {
  background: transparent;
}
.calendar-wrapper-header :hover {
  background: #158ec6;
  border-radius: 0.5rem;
}
.calendar-wrapper-header.now {
  background: #11b3a4;
}
.calendar-wrapper-header.now :hover {
  background: #0e9789;
  border-radius: 0.5rem;
}

.mat-mdc-fab, .mat-mdc-mini-fab {
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 1px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
}

.emergency {
  background-color: orange !important;
}

.locked_day {
  background-color: #353a48 !important;
}

.selected {
  background-color: #158ec6 !important;
}

.step-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
}

.step-circle.active {
  background-color: #0d6efd;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.header-bg {
  background-color: #3b82f6; /* Blue header background */
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
}

.rounded-button {
  border: 2px solid #3b82f6;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s;
}

.rounded-button:hover {
  background-color: #3b82f6;
  color: white;
}

.step-indicator .step-circle {
  width: 40px;
  height: 40px;
  background-color: #e0e0e0;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
}

.step-indicator .step-circle.active {
  background-color: #3b82f6;
}

.step-circle {
  width: 40px; /* Circle width */
  height: 40px; /* Circle height */
  border-radius: 50%; /* Make circles */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold; /* Text style */
}

.line {
  position: absolute;
  top: 50%;
  left: 100%; /* Start line after circle */
  height: 2px; /* Line thickness */
  background-color: #ccc; /* Line color */
  width: 100%; /* Full width */
  z-index: -1; /* Ensure lines are behind the circles */
}

.step:last-child .line {
  display: none; /* Hide the last line */
}

.selectedReason, .selectedPractice {
  color: white;
  font-weight: bold;
  background-color: #3b82f6;
}

::ng-deep .mat-step-header {
  pointer-events: none; /* Prevents clicking on the header */
}

.booking-summary {
  padding: 15px 0;
}

.booking-summary .title-col h5 {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
}

.summary-col {
  width: 100%;
}
.summary-col mat-card {
  border-radius: 4px;
  font-weight: 700;
}

.summary-col + .summary-col {
  padding-top: 16px;
}

.summary-col-inner {
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.0784313725);
  display: inline-block;
  width: 100%;
  padding: 15px;
}

.summary-col-inner > div + div {
  padding-top: 10px;
}

.summary-col-inner span {
  float: right;
  color: #858585;
}

::ng-deep .app.blue .mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field .mdc-notched-outline__notch {
  border-right: 1px solid transparent !important;
}

::ng-deep .mat-mdc-floating-label {
  font-family: "Montserrat";
}

::ng-deep .mat-mdc-unelevated-button > .mat-icon,
::ng-deep .mat-mdc-raised-button > .mat-icon,
::ng-deep .mat-mdc-outlined-button > .mat-icon {
  margin: 0 !important;
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

@media (min-width: 768px) {

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:block {
    display: block;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }

  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }

  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }

  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/pages/home-demo-four/search-engine-result/list-establishment/planning-list/planning-list.component.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAEA;EACE,0BAAA;AAAF;;AAEA;EACE;IACE,sBAAA;IACA,WAAA;IACA,eAAA;IACA,MAAA;IACA,gBAAA;IACA,cAAA;IACA,2BAAA;IACA,gBAAA;IACA,gBAAA;EACF;AACF;AACA;EACE,mBAAA;EACA,eAAA;AACF;;AACA;EACE;IACE,eAAA;IACA,aAAA;IACA,WAAA;EAEF;AACF;AAAA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AAAA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAKA,gCAAA;AAGF;;AADA;EACE;IACE,aAAA;IACA,mBAAA;EAIF;AACF;AAFA;EACE,yBAAA;AAIF;;AAFA;EACE;IACE,OAAA;IACA,aAAA;IACA,uBAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;IACA,sBAAA;EAKF;AACF;AAHA;EACE,YAAA;EACA,iBAAA;AAKF;;AAHA;EACE,+BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAMF;;AAJA;EACE,aAAA;EACA,kBAAA;AAOF;;AALA;EACE,2BAAA;AAQF;;AANA;EACE,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;AASF;;AAPA;;;;;EAKE,cAAA;AAUF;;AARA;EACE,eAAA;EACA,YAAA;EACA,8CAAA;AAWF;;AATA;EACE,+BAAA;EACA,aAAA;EACA,qBAAA;AAYF;;AAVA;EACE;IACE,WAAA;IACA,SAAA;EAaF;AACF;AAVA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AAWF;;AATA;EACE,QAAA;EACA,kBAAA;EACA,aAAA;AAYF;;AATA;EAEE;;IAAA;EAGA;;;;IAAA;AAeF;;AAPA;EACE,aAAA;EACA,kCAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAUF;;AARA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAWF;;AATA;EACE,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAYF;;AAVA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AAaF;;AAXA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAcF;;AAXA;EACE;IACE,eAAA;EAcF;EAZA;IACE,eAAA;IACA,iBAAA;EAcF;EAZA;IACE,iBAAA;EAcF;AACF;AAZA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAcF;;AAZA;EACE,gCAAA;EACA,yBAAA;AAeF;;AAbA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAgBF;;AAdA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAIA,0BAAA;EACA,2BAAA;EACA,2EAAA;EAGA,qBAAA;EACA,gFAAA;EACA,wFAAA;EACA,qFAAA;AAeF;;AAbA;EACE,cAAA;EACA,aAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAiBF;;AAfA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;AAmBF;;AAhBA;EACE,gBAAA;EACA,gBAAA;AAmBF;;AAjBA;EACE,gBAAA;EACA,gBAAA;AAoBF;;AAZA;EACE,UAAA;EACA,WAAA;AAeF;;AAbA;EACE,UAAA;EACA,WAAA;AAgBF;;AAdA;EACE,mBAAA;EACA,wBAAA;EACA,mBAAA;AAiBF;AAhBE;EACE,mBAAA;AAkBJ;AAhBE;EACE,mBAAA;AAkBJ;;AAfA;EACE,mBAAA;EACA,wBAAA;EACA,+BAAA;AAkBF;AAjBE;EACE,mBAAA;AAmBJ;AAjBE;EACE,mBAAA;AAmBJ;;AAhBA;EACE,uBAAA;AAmBF;;AAjBA;EACE,aAAA;AAoBF;;AAlBA;EACE,kCAAA;AAqBF;;AAnBA;EACE,8BAAA;EACA,uBAAA;AAsBF;;AApBA;EACE,mBAAA;AAuBF;;AArBA;EACE,mBAAA;AAwBF;;AAtBA;EACE,gCAAA;EACA,iCAAA;AAyBF;;AAtBA;EACE,iCAAA;AAyBF;;AAtBA;EACE,gCAAA;AAyBF;;AAvBA;EACE,gCAAA;EACA,yBAAA;AA0BF;;AAxBA;EAEE,uBAAA;AA0BF;AAzBE;EACE,mBAAA;EACA,qBAAA;AA2BJ;AAzBE;EACE,mBAAA;AA2BJ;AA1BI;EACE,mBAAA;EACA,qBAAA;AA4BN;;AAvBA;EACE,0HAAA;AA0BF;;AAxBA;EACE,mCAAA;AA2BF;;AAzBA;EACE,oCAAA;AA4BF;;AA1BA;EACE,oCAAA;AA6BF;;AA3BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AA8BF;;AA5BA;EACE,yBAAA;AA+BF;;AA7BA;EACE,eAAA;AAgCF;;AA9BA;EACE,yBAAA;AAiCF;;AA7BA;EACE,yBAAA,EAAA,2BAAA;EACA,YAAA;EACA,gCAAA;AAgCF;;AA9BA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAiCF;;AA/BA;EACE,yBAAA;EACA,YAAA;AAkCF;;AAhCA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAmCF;;AAjCA;EACE,yBAAA;AAoCF;;AAjCA;EACE,WAAA,EAAA,iBAAA;EACA,YAAA,EAAA,kBAAA;EACA,kBAAA,EAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA,EAAA,eAAA;AAoCF;;AAjCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA,EAAA,4BAAA;EACA,WAAA,EAAA,mBAAA;EACA,sBAAA,EAAA,eAAA;EACA,WAAA,EAAA,eAAA;EACA,WAAA,EAAA,wCAAA;AAoCF;;AAjCA;EACE,aAAA,EAAA,uBAAA;AAoCF;;AAhCA;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;AAmCF;;AA9BA;EACE,oBAAA,EAAA,oCAAA;AAiCF;;AA7BA;EACE,eAAA;AAgCF;;AA9BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAiCF;;AA/BA;EACE,WAAA;AAkCF;AAjCE;EACE,kBAAA;EACA,gBAAA;AAmCJ;;AAhCA;EACE,iBAAA;AAmCF;;AAjCA;EACE,mBAAA;EACA,sBAAA;EACA,oDAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;AAoCF;;AAlCA;EACE,iBAAA;AAqCF;;AAnCA;EACE,YAAA;EACA,cAAA;AAsCF;;AApCA;EACE,8CAAA;AAuCF;;AApCA;EACE,yBAAA;AAuCF;;AArCA;;;EAGE,oBAAA;AAwCF;;AAtiBA;EAAA,kBAsiBA;EAtiBA,0DAAA;AAsiBA;;AAtiBA;EAAA,kBAsiBA;EAtiBA,4DAAA;AAsiBA;;AAtiBA;EAAA,kBAsiBA;EAtiBA,yDAAA;AAsiBA;;AAtiBA;EAAA,+BAAA;AAsiBA;;AAtiBA;EAAA,+EAsiBA;EAtiBA,mGAsiBA;EAtiBA,uGAAA;AAsiBA;;AAtiBA;EAAA,8BAsiBA;EAtiBA,mBAAA;AAsiBA;;AAtiBA;EAAA,2GAsiBA;EAtiBA,yGAsiBA;EAtiBA,4FAAA;AAsiBA;;AAtiBA;EAAA,oBAsiBA;EAtiBA,6DAAA;AAsiBA;;AAtiBA;;EAAA;IAAA,4BAAA;EAsiBA;;EAtiBA;IAAA,4BAAA;EAsiBA;;EAtiBA;IAAA,cAAA;EAsiBA;;EAtiBA;IAAA,aAAA;EAsiBA;;EAtiBA;IAAA,gDAAA;EAsiBA;;EAtiBA;IAAA,gDAAA;EAsiBA;;EAtiBA;IAAA,uBAAA;EAsiBA;;EAtiBA;IAAA,eAAA;EAsiBA;AAAA;;AAtiBA;;EAAA;IAAA,sBAsiBA;IAtiBA,yDAAA;EAsiBA;;EAtiBA;IAAA,kBAsiBA;IAtiBA,yDAAA;EAsiBA;;EAtiBA;IAAA,kBAsiBA;IAtiBA,yDAAA;EAsiBA;;EAtiBA;IAAA,oBAsiBA;IAtiBA,mDAAA;EAsiBA;;EAtiBA;IAAA,kBAsiBA;IAtiBA,yDAAA;EAsiBA;;EAtiBA;IAAA,kBAsiBA;IAtiBA,yDAAA;EAsiBA;;EAtiBA;IAAA,oBAsiBA;IAtiBA,mDAAA;EAsiBA;AAAA;AAkmCA,4g+BAA4g+B","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.appointment-popup {\n  padding: 3px 0px 10px 15px;\n}\n@media screen and (max-width: 768px) {\n  .appointment-popup {\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n    top: 0;\n    border-radius: 0;\n    overflow: auto;\n    height: calc(100% - 6.4rem);\n    min-height: auto;\n    max-height: 100%;\n  }\n}\n.appointment-popup .appointment-user-wrapper {\n  background: #2c3153;\n  flex: 0 0 25rem;\n}\n@media screen and (max-width: 768px) {\n  .appointment-popup .appointment-user-wrapper {\n    flex-wrap: wrap;\n    display: flex;\n    width: 100%;\n  }\n}\n.appointment-popup .appointment-user-wrapper .user-avatar {\n  position: relative;\n  padding-bottom: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.appointment-popup .appointment-user-wrapper .user-avatar img {\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n@media screen and (max-width: 768px) {\n  .appointment-popup .appointment-user-wrapper .user-avatar {\n    flex: 0 0 35%;\n    padding-bottom: 35%;\n  }\n}\n.appointment-popup .appointment-user-wrapper .appointment-user {\n  padding: 2rem 2rem 0 2rem;\n}\n@media screen and (max-width: 768px) {\n  .appointment-popup .appointment-user-wrapper .appointment-user {\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding: 2rem;\n    flex-direction: column;\n  }\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .username {\n  color: white;\n  font-size: 1.8rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .specialization {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 1.3rem;\n  display: block;\n  margin-top: 0.5rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation {\n  display: flex;\n  margin-top: 0.5rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation span {\n  padding: 0.25rem !important;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation span:before {\n  content: \"\\f005\";\n  font-family: 'Font Awesome 5 Pro';\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.5);\n  display: block;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.five span:nth-child(-n+5):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.four span:nth-child(-n+4):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.three span:nth-child(-n+3):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.two span:nth-child(-n+2):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.one span:nth-child(-n+1):before {\n  color: #ee5181;\n}\n.appointment-popup .appointment-user-wrapper .appointment-location {\n  padding: 2rem 0;\n  margin: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.5);\n}\n.appointment-popup .appointment-user-wrapper .appointment-location p {\n  color: rgba(255, 255, 255, 0.5);\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n@media screen and (max-width: 768px) {\n  .appointment-popup .appointment-user-wrapper .appointment-location {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n.appointment-popup .appointment-calendar {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  //box-shadow: 0 0 4px rgb(0 0 0 / 20%);\n  position: relative;\n  /* padding: 10px 8px; */\n  /* left: 50%; */\n  /* max-width: 90%; */\n  background: white;\n  border-radius: 8px;\n  z-index: 1;\n  /* transform: translateX(-50%);*/\n}\n.appointment-popup .appointment-calendar .calendar-nav {\n  right: 0;\n  position: absolute;\n  margin-top: 0;\n}\n\n.current-week {\n\n  /*mat-icon {\n      font-size: 20px;\n  }*/\n  /*.calendar-nav {\n      mat-icon {\n          font-size: 18px;\n      }\n  }*/\n}\n\n\n.appointment-popup .appointment-calendar .current-week {\n  display: flex;\n  /*justify-content: space-between;*/\n  padding: 8px 0;\n  border-bottom: 1px solid #f3f3f3;\n  align-items: center;\n  width: auto;\n  justify-content: space-between;\n}\n.appointment-popup .appointment-calendar .current-week > span {\n  font-size: 16px;\n  color: #5a5a5a;\n  padding-left: 25px;\n  line-height: 40px;\n  clear: both;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.appointment-popup .appointment-calendar .current-week > span i {\n  color: #333333;\n  margin-right: 0.5rem;\n  opacity: 0.7;\n  width: 20px;\n  text-align: center;\n}\n.appointment-popup .appointment-calendar .current-week .calendar-nav button {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 0;\n  cursor: pointer;\n  outline: none;\n  color: #515151;\n  width: 50px;\n}\n.appointment-popup .appointment-calendar .current-week .calendar-nav button:before {\n  font-family: \"Font Awesome 5 Pro\";\n  font-size: 2rem;\n  padding: 0 1.5rem;\n  display: block;\n}\n\n@media screen and (max-width: 768px) {\n  .appointment-popup .appointment-calendar .current-week .calendar-nav {\n    flex-wrap: wrap;\n  }\n  .appointment-popup .appointment-calendar .current-week .calendar-nav .calendar-nav button:before {\n    padding: 0 1rem;\n    font-size: 1.2rem;\n  }\n  .appointment-popup .appointment-calendar .current-week .calendar-nav > span {\n    font-size: 1.5rem;\n  }\n}\n.appointment-popup .appointment-calendar .calendar-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week {\n  border-bottom: 2px solid #158ec6;\n  background-color: #353a48;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul {\n  padding: 0;\n  list-style: none;\n  display: flex;\n  width: 100%;\n  margin: 0;\n  height: 55px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul li {\n  width: 100%;\n  font-weight: 600;\n  padding: 0.25rem 0;\n  text-align: center;\n  color: #d6d6d6;\n  -webkit-background-size: 100% 100%;\n  -moz-background-size: 100% 100%;\n  -o-background-size: 100% 100%;\n  background-size: 100% 100%;\n  background: rgb(84,84,84);\n  background: linear-gradient(3deg, rgba(84,84,84,1) 0%, rgba(68,68,68,1) 100%);\n\n\n  border-color: #333333;\n  box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours {\n  overflow: auto;\n  height: 290px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  padding: 5px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li {\n  width: 100%;\n  text-align: center;\n  padding-top: 8px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  /* min-height: 0.7rem; */\n  cursor: pointer;\n  background: #11b3a4;\n  border-radius: 3px;\n  color: white;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n  margin-bottom: 6px;\n}\n\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty {\n  background: none;\n  box-shadow: none;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty:hover {\n  background: none;\n  box-shadow: none;\n}\n\n\n\n\n\n\n.calendar-hours::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n.calendar-hours::-webkit-scrollbar-button {\n  width: 0px;\n  height: 0px;\n}\n.calendar-hours::-webkit-scrollbar-thumb {\n  background: #158ec6;\n  border: 0px none #ffffff;\n  border-radius: 12px;\n  &:hover{\n    background: #919191;\n  }\n  &:active{\n    background: #158ec6;\n  }\n}\n.calendar-hours::-webkit-scrollbar-track {\n  background: #666666;\n  border: 0px none #ffffff;\n  border-bottom-right-radius: 6px;\n  &:hover{\n    background: #666666;\n  }\n  &:active{\n    background: #888888;\n  }\n}\n.calendar-hours::-webkit-scrollbar-corner {\n  background: transparent;\n}\n.message-not-available-planning{\n  height: 100px;\n}\n.btn-select-type{\n  background: transparent !important;\n}\n.selected-type{\n  background: #11b3a4 !important;\n  color: white !important;\n}\n.select-lieux-consultation{\n  background: #11b3a4;\n}\n.select-motif{\n  background: #11b3a4;\n}\n.li-slot:not(:last-child):not(:first-child) {\n  border-left: 0.5px solid #eaeaec;\n  border-right: 0.5px solid #eaeaec;\n}\n\n.li-slot:first-child {\n  border-right: 0.5px solid #eaeaec;\n}\n\n.li-slot:last-child {\n  border-left: 0.5px solid #eaeaec;\n}\n.top-header-planning{\n  border-bottom: 2px solid #158ec6;\n  background-color: #353a48;\n}\n.calendar-wrapper-header\n{\n  background: transparent;\n  :hover {\n    background: #158ec6;\n    border-radius: 0.5rem;\n  }\n  &.now{\n    background: #11b3a4;\n    :hover {\n      background: #0e9789;\n      border-radius: 0.5rem;\n    }\n  }\n}\n//Fix shadow of icons\n.mat-mdc-fab, .mat-mdc-mini-fab{\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 1px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)\n}\n.emergency {\n  background-color: orange !important;\n}\n.locked_day{\n  background-color: #353a48 !important;\n}\n.selected {\n  background-color: #158ec6 !important;\n}\n.step-circle {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 18px;\n  color: white;\n}\n.step-circle.active {\n  background-color: #0d6efd;\n}\n.list-group-item {\n  cursor: pointer;\n}\n.list-group-item:hover {\n  background-color: #f8f9fa;\n}\n\n\n.header-bg {\n  background-color: #3b82f6; /* Blue header background */\n  color: white;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.rounded-button {\n  border: 2px solid #3b82f6;\n  border-radius: 10px;\n  font-weight: bold;\n  transition: all 0.3s;\n}\n.rounded-button:hover {\n  background-color: #3b82f6;\n  color: white;\n}\n.step-indicator .step-circle {\n  width: 40px;\n  height: 40px;\n  background-color: #e0e0e0;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  font-weight: bold;\n}\n.step-indicator .step-circle.active {\n  background-color: #3b82f6;\n}\n\n.step-circle {\n  width: 40px; /* Circle width */\n  height: 40px; /* Circle height */\n  border-radius: 50%; /* Make circles */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold; /* Text style */\n}\n\n.line {\n  position: absolute;\n  top: 50%;\n  left: 100%; /* Start line after circle */\n  height: 2px; /* Line thickness */\n  background-color: #ccc; /* Line color */\n  width: 100%; /* Full width */\n  z-index: -1; /* Ensure lines are behind the circles */\n}\n\n.step:last-child .line {\n  display: none; /* Hide the last line */\n}\n\n\n.selectedReason,.selectedPractice{\n  color: white;\n  font-weight: bold;\n  background-color: #3b82f6;\n}\n\n\n//planning\n::ng-deep .mat-step-header {\n  pointer-events: none; /* Prevents clicking on the header */\n}\n\n\n.booking-summary {\n  padding: 15px 0;\n}\n.booking-summary .title-col h5 {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n.summary-col {\n  width: 100%;\n  mat-card {\n    border-radius: 4px;\n    font-weight: 700;\n  }\n}\n.summary-col + .summary-col {\n  padding-top: 16px;\n}\n.summary-col-inner {\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0px 6px 15px #00000014;\n  display: inline-block;\n  width: 100%;\n  padding: 15px;\n}\n.summary-col-inner > div + div {\n  padding-top: 10px;\n}\n.summary-col-inner span {\n  float: right;\n  color: #858585;\n}\n::ng-deep .app.blue .mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field .mdc-notched-outline__notch{\n  border-right: 1px solid transparent !important;\n}\n\n::ng-deep .mat-mdc-floating-label{\n  font-family: \"Montserrat\";\n}\n::ng-deep .mat-mdc-unelevated-button>.mat-icon,\n::ng-deep .mat-mdc-raised-button>.mat-icon,\n::ng-deep .mat-mdc-outlined-button>.mat-icon{\n  margin:0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
